export default __webpack_public_path__ + "static/media/image01.d2919702.jpg";